const device = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) ? 'mobile' : 'pc';//设备

export default {
    device,
}


// WEBPACK FOOTER //
// ./src/directives/config/public.js